<template>
  <b-modal ref="modal" hide-footer title="Add Note">
    <b-row class="my-1">
      <b-col md="3">
        <label for="notes">Note Details</label>
      </b-col>
      <b-col md="9">
        <b-form-textarea
          id="notes"
          v-model="form.notes"
        ></b-form-textarea>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label for="noteType">Note Type</label>
      </b-col>
      <b-col md="6">
        <b-form-select
          id="noteTypeId"
          v-model="form.noteTypeId"
          :options="noteTypes"
          value-field="id"
          text-field="name"
        ></b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3"></b-col>
      <b-col md="9">
        <b-form-checkbox v-model="form.sendToRandD">
          Send To randd
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3"></b-col>
      <b-col md="9">
        <b-form-checkbox v-model="form.sendToHo">
         Send To HO
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3">
      </b-col>
      <b-col md="9">
        <b-button type="submit" variant="success" class="margin-right" @click="save" :disabled="!form.noteTypeId || !form.notes">
          <font-awesome-icon icon="save" /> Save
        </b-button>
        <b-button type="reset" variant="danger" @click="cancel">
          <font-awesome-icon icon="times" /> Cancel Changes
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
//import store from '@/helpers/Store'
export default {
  props: ['systemId', 'companyId'],
  data() {
    return {
      noteTypes: [],
      form: {
        companyId: this.$props.companyId,
        notes: "",
        noteTypeId: 130,
        sendToRandD: false,
        sendToHo: false,
      },
    };
  },
  mounted() {
    this.$http.get('lookups/companynotetypes').then((response) => {      
      this.noteTypes = response.data;
    });
  },
  methods: {
    showModal() {
      this.$refs["modal"].show();
    },
    hideModal() {
      this.$refs["modal"].hide();
    },
    cancel() {
      this.clear();
      this.$refs["modal"].hide();
    },
    save() {
      this.form.companyId = this.$props.companyId;
      this.$http.post('CompanyNotes', this.form).then(() => {
        this.clear();
        this.$parent.loadNotes();
        this.$refs["modal"].hide();
      });
    },
    clear() {
      this.form.notes = "";
      this.form.sendToRandD = false;
      this.form.sendToHo = false;
    }
  }
};
</script>

<style scoped>
</style>
